import {autoImplement} from '@/util';
import moment from 'moment';

export interface ApiArticlePrice {
  ID: number;
  DBID: number;
  KundenGruppe: number;
  Niederlassung: number;
  PreisTabelleNr: number;
  DatumVon: string;
  DatumBis: string | null;
  BisMenge: number | null;
  Netto: number;
  Brutto: number;
  AbMenge: number | null;
}

export class ArticlePrice extends autoImplement<ApiArticlePrice>() {
  static fromApi(apiArticlePrice: ApiArticlePrice) {
    return new ArticlePrice(apiArticlePrice);
  }

  get DatumBisParsed() {
    if (!this.DatumBis) return null;
    return moment(this.DatumBis);
  }

  get DatumVonParsed() {
    return moment(this.DatumVon);
  }

  get isActive() {
    if (this.DatumVonParsed.isAfter()) return false; // not yet active
    if (this.DatumBisParsed?.isBefore()) return false; // not active anymore

    return true;
  }

  get qtyString() {
    if (!this.AbMenge && !this.BisMenge) return null;
    return `ab ${this.AbMenge}`;
  }

  get dateString() {
    let datumBis;
    if (datumBis = this.DatumBisParsed) {
      return `${this.DatumVonParsed.format('DD.MM.YY')}–${datumBis.format('DD.MM.YY')}`;
    }

    if (this.isActive) {
      return `seit ${this.DatumVonParsed.format('DD.MM.YY')}`;
    }
    return `ab ${this.DatumVonParsed.format('DD.MM.YY')}`;
  }

  get key() {
    return `${this.DBID}-${this.ID}-${this.AbMenge}-${this.BisMenge}`;
  }
}
